module.exports = __webpack_public_path__ + "static/media/networking.1e73d0dd.png";